import React from 'react';
import moment from 'moment';

import { SearchTextField, MCButton, MCText } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { TableLibrary } from 'src/components/complex';

import { getDoctorChatTicketLabel, remCss, lang, withRouter, permissions } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';
import ShortInfo from 'src/components/user/ShortInfo';
import constants from 'src/constants';
import { BASE_ICONS } from 'src/components/svg';

class Tickets extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (!model.initFlag) {
      model.refresh();
      model.initFlag = true;
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();

    const columns = [
      {
        label: LANG_CONST.clients,
        resize: true,
        renderCell: (item) => {
          const patient = item.patient || {};
          return <ShortInfo user={patient} specialist={[]} to={permissions.profilePath(patient)} />;
        }
      },
      {
        label: LANG_CONST.charges,
        resize: true,
        renderCell: (item) => (
          <MCText
            label={
              getDoctorChatTicketLabel(
                item.charge,
                item.charge?.currency || constants.general.defaultCurrency
              ) || ''
            }
          />
        )
      },
      {
        label: LANG_CONST.doctors,
        resize: true,
        renderCell: (item) => {
          const doctor = item.doctor || {};
          return <ShortInfo user={doctor} to={permissions.profilePath(doctor)} />;
        }
      },
      {
        label: LANG_CONST.clinics,
        resize: true,
        renderCell: (item) => {
          const clinic = item.clinic || {};
          if (!clinic?.id) return null;
          return <ShortInfo user={clinic} to={permissions.profilePath(clinic)} />;
        }
      },
      {
        label: LANG_CONST.date,
        resize: true,
        width: `${remCss(180)}px`,
        renderCell: (item) => moment(item.startDate).format('DD - MMM - YYYY')
      },
      {
        label: LANG_CONST.actions,
        cellStyles: { textAlign: 'end' },
        width: `${remCss(100)}px`,
        renderCell: (item) => (
          <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
            <MCButton
              iconname={BASE_ICONS.EYE_FILL}
              medium
              radius
              primary
              dark
              onClick={() => {
                permissions.switchToFront();
                model.logAsDoctor(item.doctor);
              }}
            />
          </div>
        )
      }
    ].filter((c) => !!c);

    return (
      <div className={'mc-container-content'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.chat_tickets)}</span>
          <SearchTextField
            width={300}
            template={'2'}
            onChange={(text) => {
              model.setStateSilent({
                pageIndex: 0
              });
              model.setListStateSilent({ items: [], total: 0 }, 'search');
              model.handleChangeSearch(text);
              if (!text) {
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.refresh();
              }
            }}
            value={model.listInput('search')}
          />
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
            <TableLibrary
              columns={columns}
              data={items}
              loading={loading}
              noResults={noResults}
              searchQuery={searchQuery}
              sortBy={model.state.sortBy}
              selectedPage={model.state.pageIndex}
              total={total}
              limit={model.listLimit}
              onSortChange={(sortBy) => {
                model.handleChange('sortBy', sortBy);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              onSetPage={(v) => {
                model.handleChange('pageIndex', v);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              otherProps={{
                cell: () => ({
                  style: {
                    alignItems: 'flex-start'
                  }
                })
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Tickets);
